
export interface HcContact {
  _id: string;
  csId: string;
  firstName: string;
  lastName: string;
  phoneNumber: string;
  countryCode: string;
  email: string;
  timezone: string;
  languageId: string; // Reference to HcLanguage
  /** Set true only after Twilio Verify succeeds. Missing or false blocks notification SMS/voice and flow activation. */
  numberHasBeenValidated?: boolean;
}
